import styled from "styled-components";

import { Box } from "shared/ui-kit";

export const Wrapper = styled(Box)`
	width: 640px;
	margin: 0 auto;

	${props => props.theme.breakpoints.down("sm")} {
		width: 95%;
	}
`;
